// TikTok Swiper Implementation
class TikTokSwiper {
  constructor(element) {
    this.element = element;
    this.swiperElement = element.querySelector('.tiktok-swiper');

    // Configuration
    this.itemsDesktop = parseInt(element.dataset.items) || 4;
    this.itemsMobile = parseInt(element.dataset.mobile) || 1;
    this.gap = this.getGapValue(element.dataset.gap);

    this.init();
  }

  getGapValue(gap) {
    const gapMap = {
      'no_gap': 0,
      'small': 10,
      'medium': 20,
      'large': 30
    };
    return gapMap[gap] || 20;
  }

  init() {
    // Initialize Swiper
    this.swiper = new Swiper(this.swiperElement, {
      // Core parameters
      slidesPerView: 1,
      spaceBetween: 0, // Disable Swiper's spaceBetween, use CSS gap instead
      slidesOffsetAfter: 0,
      slidesOffsetBefore: 0,
      cssMode: false,

      // Responsive breakpoints
      breakpoints: {
        // Mobile
        320: {
          slidesPerView: this.itemsMobile,
          spaceBetween: 0
        },
        // Tablet
        768: {
          slidesPerView: Math.min(this.itemsDesktop, 2),
          spaceBetween: 0
        },
        // Desktop
        1024: {
          slidesPerView: this.itemsDesktop,
          spaceBetween: 0
        }
      },

      // Navigation arrows
      navigation: {
        nextEl: '.tiktok-swiper-next',
        prevEl: '.tiktok-swiper-prev',
      },

      // Pagination
      pagination: {
        el: '.tiktok-swiper-pagination',
        clickable: true,
        dynamicBullets: true,
      },

      // Touch gestures
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,

      // Effects
      effect: 'slide',
      speed: 400,

      // Auto height
      autoHeight: false,

      // Center slides
      centeredSlides: false,

      // Loop (if more than slides per view)
      loop: false,

      // Lazy loading for iframes
      lazy: {
        loadPrevNext: true,
      },

      // Watch for changes
      observer: true,
      observeParents: true,

      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous TikTok video',
        nextSlideMessage: 'Next TikTok video',
        paginationBulletMessage: 'Go to TikTok video {{index}}'
      }
    });

    // Handle scroll animations if enabled
    if (typeof window.scrollTriggerAnimations !== 'undefined') {
      this.setupScrollAnimations();
    }
  }

  setupScrollAnimations() {
    const slides = this.swiperElement.querySelectorAll('.swiper-slide[data-cascade]');

    // Simple intersection observer for cascade animation
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('animate');
          }, 100);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });

    slides.forEach(slide => observer.observe(slide));
  }

  // Destroy method for cleanup
  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

// Auto-initialize all TikTok swipers
function initTikTokSwipers() {
  const swipers = document.querySelectorAll('.tiktok-swiper-wrapper');

  // Store swiper instances for cleanup
  window.tiktokSwipers = window.tiktokSwipers || [];

  // Destroy existing instances
  window.tiktokSwipers.forEach(swiperInstance => {
    if (swiperInstance && swiperInstance.destroy) {
      swiperInstance.destroy();
    }
  });

  // Clear array
  window.tiktokSwipers = [];

  // Initialize new instances
  swipers.forEach(swiperWrapper => {
    const tiktokSwiper = new TikTokSwiper(swiperWrapper);
    window.tiktokSwipers.push(tiktokSwiper);
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initTikTokSwipers);

// Re-initialize on theme editor updates
document.addEventListener('shopify:section:load', initTikTokSwipers);

// Handle theme editor section unload
document.addEventListener('shopify:section:unload', () => {
  if (window.tiktokSwipers) {
    window.tiktokSwipers.forEach(swiperInstance => {
      if (swiperInstance && swiperInstance.destroy) {
        swiperInstance.destroy();
      }
    });
    window.tiktokSwipers = [];
  }
});